if (!customElements.get('td-variant-selects')) {

    /**
     *  @class
     *  @function VariantSelects
     */
    class TdVariantSelects extends HTMLElement {
      constructor() {
        super();
        this.sticky = this.dataset.sticky;
        this.featured = this.dataset.featured;
        this.isDisabledFeature = this.dataset.isDisabled;
        this.addEventListener('change', this.onVariantChange);
        this.other = Array.from(document.querySelectorAll('td-variant-selects')).filter((selector) => {
          return selector != this;
        });
      
      }
  
      connectedCallback() {
        setTimeout(() => {
          this.updateOptions();
          this.updateMasterId();
          this.setDisabled();
        }, 0);       
      }
  
      onVariantChange() {
        this.updateOptions();
        this.updateMasterId();
        this.toggleAddButton(true, '', false);
        this.updatePickupAvailability();
        this.removeErrorMessage();
        this.updateVariantText();
        this.setDisabled();
        this.updateWishlist();
  
        if (!this.currentVariant) {
          this.toggleAddButton(true, '', true);
          this.setUnavailable();
        } else {
          this.updateMedia();
          if (!this.featured) {
            this.updateURL();
          }
          this.updateVariantInput();
          this.renderProductInfo();
          //this.updateShareUrl();
        }
  
        this.updateOther();
        dispatchCustomEvent('product:variant-change', {
          variant: this.currentVariant
        });
        setTimeout(() => {
          const tontineEvent = new CustomEvent('variant:change', {detail: {variant: this.currentVariant}});
          document.dispatchEvent(tontineEvent);
        }, 300)
      }
  
      updateOptions() {
        this.fieldsets = Array.from(this.querySelectorAll('fieldset'));
        this.options = [];
        this.fieldsets.forEach((fieldset, i) => {
          if (fieldset.querySelector('select')) {
            this.options.push(fieldset.querySelector('select').value);
          } else if (fieldset.querySelectorAll('input').length) {
            this.options.push(fieldset.querySelector('input:checked').value);
          }
        });
      }
      updateVariantText() {
        const fieldsets = Array.from(this.querySelectorAll('fieldset'));
        fieldsets.forEach((item, i) => {
          let label = item.querySelector('.form__label__value');
          if (label) {
            label.innerHTML = this.options[i];
          }
        });
      }
      updateMasterId() {
        this.currentVariant = this.getVariantData().find((variant) => {
          return !variant.options.map((option, index) => {
            return this.options[index] === option;
          }).includes(false);
        });
      }
  
      updateOther() {
        if (this.dataset.updateUrl === 'false') {
          return;
        }
        if (this.other.length) {
          let fieldsets = this.other[0].querySelectorAll('fieldset'),
            fieldsets_array = Array.from(fieldsets);
          this.options.forEach((option, i) => {
            if (fieldsets_array[i].querySelector('select')) {
              fieldsets_array[i].querySelector(`select`).value = option;
            } else if (fieldsets_array[i].querySelectorAll('input').length) {
              fieldsets_array[i].querySelector(`input[value="${option}"]`).checked = true;
            }
          });
          this.other[0].updateOptions();
          this.other[0].updateMasterId();
          this.other[0].updateVariantText();
          this.other[0].setDisabled();
        }
      }
  
      updateMedia() {
        if (!this.currentVariant) return;
        if (!this.currentVariant.featured_media) return;
  
        const productSlider = document.getElementById(`MediaGallery-${this.dataset.section}`);
        if (!productSlider) return;
        let mediaId = `${this.dataset.section}-${this.currentVariant.featured_media.id}`;
        let activeMedia = productSlider.querySelector(`[data-media-id="${ mediaId }"]`);
  
        productSlider.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia.classList.add('is-active');
  
        if (this.featured) return;
  
        activeMedia.parentElement.prepend(activeMedia);
  
        window.setTimeout(() => {
          activeMedia.parentElement.scrollTo({
            left: 0,
            top: 0,
            behavior: 'smooth'
          });
        });
      }
      updateWishlist() {
        // NOTE Status does not provide events for this
        if (!this.currentVariant) return;
        const saveButton = document.querySelector('.product-grid-container status-save-button ')
        if (saveButton) {
          saveButton.setAttribute('variant-id', this.currentVariant.id)
        }
      }
      updateURL() {
        if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
        window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
      }
  
      updateShareUrl() {
        const shareButton = document.getElementById(`Share-${this.dataset.section}`);
        if (!shareButton) return;
        shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
      }
  
      updateVariantInput() {
        const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
        productForms.forEach((productForm) => {
          const input = productForm.querySelector('input[name="id"]');
          input.value = this.currentVariant.id;
          input.dispatchEvent(new Event('change', {
            bubbles: true
          }));
        });
      }
  
      updatePickupAvailability() {
        const pickUpAvailability = document.querySelector('.pickup-availability-wrapper');
  
        if (!pickUpAvailability) return;
  
        if (this.currentVariant && this.currentVariant.available) {
          pickUpAvailability.fetchAvailability(this.currentVariant.id);
        } else {
          pickUpAvailability.removeAttribute('available');
          pickUpAvailability.innerHTML = '';
        }
      }
  
      removeErrorMessage() {
        const section = this.closest('section');
        if (!section) return;
  
        const productForm = section.querySelector('product-form');
        if (productForm) productForm.handleErrorMessage();
      }
  
      getSectionsToRender() {
        return [`price-${this.dataset.section}`, `price-${this.dataset.section}--sticky`, `product-image-${this.dataset.section}--sticky`, `inventory-${this.dataset.section}`, `sku-${this.dataset.section}`];
      }
  
      renderProductInfo() {
        
        let sections = this.getSectionsToRender();
  
        fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
          .then((response) => response.text())
          .then((responseText) => {
            sections.forEach((id) => {
              const html = new DOMParser().parseFromString(responseText, 'text/html');
              const destination = document.getElementById(id);
              const source = html.getElementById(id);
              if(source && destination && source.classList.contains('product-add-to-cart-sticky--image')) {
                destination.classList.remove('toggle-image')
              }
              
              if (source && destination){
                 
                 if(source.classList.contains('product-add-to-cart-sticky--image')) {
                  destination.innerHTML = source.innerHTML;
                  const img = destination.querySelector('img')
                  if(img) {
                    img.onload = function() {
                      setTimeout(() => {
                        destination.classList.add('toggle-image')
                      }, 300)
                    }
                  }
                 
                 
                  
                 }else {
                  destination.innerHTML = source.innerHTML;
                 }     
                            
              }
  
              const price = document.getElementById(id);
              const price_fixed = document.getElementById(id + '--sticky');
  
              if (price) price.classList.remove('visibility-hidden');
              if (price_fixed) price_fixed.classList.remove('visibility-hidden');
  
            });
            this.toggleAddButton(!this.currentVariant.available, window.theme.variantStrings.soldOut);
            dispatchCustomEvent('product:variant-rendered', {
              variant: this.currentVariant
            });
          });
      }
  
      toggleAddButton(disable = true, text = false, modifyClass = true) {
        const productForm = document.getElementById(`product-form-${this.dataset.section}`);
        if (!productForm) return;
  
        const submitButtons = document.querySelectorAll('.single-add-to-cart-button');
  
        if (!submitButtons) return;
  
        submitButtons.forEach((submitButton) => {
          const submitButtonText = submitButton.querySelector('.single-add-to-cart-button--text');
  
          if (!submitButtonText) return;
  
          if (disable) {
            submitButton.setAttribute('disabled', 'disabled');
            if (text) submitButtonText.textContent = text;
          } else {
            submitButton.removeAttribute('disabled');
            submitButton.classList.remove('loading');
            submitButtonText.textContent = window.theme.variantStrings.addToCart;
          }
        });
  
        if (!modifyClass) return;
      }
  
      setUnavailable() {
        const submitButtons = document.querySelectorAll('.single-add-to-cart-button');
        const price = document.getElementById(`price-${this.dataset.section}`);
        const price_fixed = document.getElementById(`price-${this.dataset.section}--sticky`);
  
        submitButtons.forEach((submitButton) => {
          const submitButtonText = submitButton.querySelector('.single-add-to-cart-button--text');
          if (!submitButton) return;
          submitButtonText.textContent = window.theme.variantStrings.soldOut;
          submitButton.classList.add('sold-out');
        });
        if (price) price.classList.add('visibility-hidden');
        if (price_fixed) price_fixed.classList.add('visibility-hidden');
      }
  
      setDisabled() {
        if (this.isDisabledFeature != 'true') {
          return;
        }
        const variant_data = this.getVariantData();
  
  
        if (variant_data) {
  
          const selected_options = this.currentVariant.options.map((value, index) => {
            return {
              value,
              index: `option${index+1}`
            };
          });
          const available_options = this.createAvailableOptionsTree(variant_data, selected_options);
  
  
          this.fieldsets.forEach((fieldset, i) => {
            const fieldset_options = Object.values(available_options)[i];
  
            if (fieldset_options) {
              if (fieldset.querySelector('select')) {
                fieldset_options.forEach((option, option_i) => {
                  if (option.isUnavailable) {
                    fieldset.querySelector('option[value=' + JSON.stringify(option.value) + ']').disabled = true;
                  } else {
                    fieldset.querySelector('option[value=' + JSON.stringify(option.value) + ']').disabled = false;
                  }
                });
              } else if (fieldset.querySelectorAll('input').length) {
                fieldset.querySelectorAll('input').forEach((input, input_i) => {
                  input.classList.toggle('is-disabled', fieldset_options[input_i].isUnavailable);
                });
              }
            }
          });
  
        }
        return true;
      }
      createAvailableOptionsTree(variant_data, selected_options) {
      
        // Reduce variant array into option availability tree
        return variant_data.reduce((options, variant) => {
          // Check each option group (e.g. option1, option2, option3) of the variant
          Object.keys(options).forEach(index => {
  
            if (variant[index] === null) return;
  
            let entry = options[index].find(option => option.value === variant[index]);
  
            if (typeof entry === 'undefined') {
              // If option has yet to be added to the options tree, add it
              entry = {
                value: variant[index],
                isUnavailable: true
              };
              options[index].push(entry);
            }
  
            // Check how many selected option values match a variant
            const countVariantOptionsThatMatchCurrent = selected_options.reduce((count, {
              value,
              index
            }) => {
              return variant[index] === value ? count + 1 : count;
            }, 0);
  
            // Only enable an option if an available variant matches all but one current selected value
            // NOTE added outOfStockVariant Check
            if (countVariantOptionsThatMatchCurrent >= selected_options.length - 1) {
              entry.isUnavailable = entry.isUnavailable && variant.available ? false : entry.isUnavailable;
            }
  
            // Make sure if a variant is unavailable, disable currently selected option
            if ((!this.currentVariant || !this.currentVariant.available) && selected_options.find((option) => option.value === entry.value && index === option.index)) {
              entry.isUnavailable = true;
            }
  
            // First option is always enabled
            if (index === 'option1') {
              entry.isUnavailable = entry.isUnavailable && variant.available ? false : entry.isUnavailable;
            }
          });
          return options;
        }, {
          option1: [],
          option2: [],
          option3: []
        });
      }
  
      getVariantData() {
        this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
        return this.variantData;
      }
    }
    customElements.define('td-variant-selects', TdVariantSelects);
  
    /**
     *  @class
     *  @function VariantRadios
     */
    class TdVariantRadios extends TdVariantSelects {
      constructor() {
        super();
       
      }
  
      updateOptions() {
        const fieldsets = Array.from(this.querySelectorAll('fieldset'));
        this.options = fieldsets.map((fieldset) => {
          return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
        });
      }
    }
  
    customElements.define('td-variant-radios', TdVariantRadios);
  }